export const initState = {
  loaded: false,
  isAdmin: false,
  std: "",
  stn: "",
  pho: "",
  sub: "",
  rol: 0,
  miniappBarcodePath: undefined
};
